import { Pages } from '.generated/Project.CW.model';
import type { MedicalCondition, WithContext } from 'schema-dts';
import { stripHtmlTags } from 'lib/utils/string-utils';
import { MinimalSchemaItem } from './minimal-schema-item';

export const buildConditionPageJsonLd = (
  data: Pages.ConditionOrTreatment,
  pageUrl: string,
  relatedTreatment: MinimalSchemaItem[]
): WithContext<MedicalCondition> => {
  const possibleTreatment = relatedTreatment?.length
    ? relatedTreatment.map((treatment) => ({
        '@type': treatment.treatmentTypes?.targetItem?.name,
        '@id': treatment.url.path,
        url: treatment.url.path,
        name: treatment.name,
      }))
    : undefined;
  const base = {
    '@context': 'https://schema.org' as const,
    '@type': 'MedicalCondition' as const,
    name: data.fields?.Title?.value,
    description: stripHtmlTags(data.fields?.Description?.value),
    url: pageUrl,
    possibleTreatment,
    '@id': pageUrl,
  };
  return possibleTreatment ? { ...base, possibleTreatment } : base;
};
